<template>
    <div class="admin-switch inline-flex select-none shadow-inset bg-neutral-200 dark:bg-neutral-900" :dusk="dusk">
        <label
            v-for="option in options"
            :key="option.id"
            class="admin-switch__option inline-flex items-center px-2 py-1 border cursor-pointer border-neutral-300 dark:border-neutral-900"
            :class="[
                option.id === modelValue
                    ? 'is-active bg-brand-200 text-brand-900 dark:bg-brand-900 dark:text-brand-200'
                    : 'text-neutral-600',
            ]"
        >
            <AdminRadio
                v-model="modelValue"
                :value="option.id"
                :size="size"
                :required="required"
                class="hidden peer/switch"
            />
            <div class="inline-flex items-center space-x-2">
                <Icon :icon="option.icon" class="size-4" />
                <span class="text-sm">
                    {{ option.name }}
                </span>
            </div>
        </label>
    </div>
</template>

<script setup lang="ts">
import { computed, toRef } from 'vue';
import type { FieldComponent } from '@src/Common/Components/types';

const props = defineProps<FieldComponent>();

const emit = defineEmits(['update:modelValue']);

const modelValue = computed({
    get: () => props.modelValue,
    set: (val: string | number) => emit('update:modelValue', val),
});

const options = toRef(props, 'options');
</script>
